'use strict';

import Plyr from 'plyr';
import Tracking from './tracking';

/**
 * Third-party players only load once the `embed` tracking service is accepted:
 * - the theme YouTube block (Plyr), see acf-blocks/templates/youtube.php
 * - any other YouTube iframe, whose src was replaced by a srcdoc placeholder (Sevanova_Tracking::gate_youtube_iframes)
 * - the YouTube API of the sevanova-gutenberg-block-youtube plugin, kept in a <template>
 * Must be initialized before Tracking, which dispatches the consent event on page load
 */
export default class Embed {
    constructor() {
        this.$$blocks = document.querySelectorAll('[data-tracking="embed"]');
        this.$$iframes = document.querySelectorAll('iframe[data-consent-src]');

        if (!this.$$blocks.length && !this.$$iframes.length) {
            return;
        }

        this.$$blocks.forEach(($item) => {
            $item.querySelector('.youtube-block__consent-btn')?.addEventListener('click', () => Tracking.addTrackingService('embed'));
        });

        // "Accept" button inside the srcdoc placeholders (their origin is opaque, so the sender is checked instead)
        window.addEventListener('message', (e) => {
            if (e.data === 'GRAHOU_tracking_accept_embed' && [...this.$$iframes].some(($iframe) => $iframe.contentWindow === e.source)) {
                Tracking.addTrackingService('embed');
            }
        });

        document.body.addEventListener('GRAHOU_tracking_consent_embed', this.#activate.bind(this));
        document.body.addEventListener('GRAHOU_tracking_refuse_embed', this.#disable.bind(this));
    }

    #activate() {
        this.$$blocks.forEach(($item) => {
            if (!$item.classList.contains('no_consent')) {
                return;
            }

            const $iframe = $item.querySelector('iframe');
            $iframe.src = $iframe.dataset.src;
            $item.classList.remove('no_consent');
            $item.player = new Plyr($iframe.parentElement);
        });

        this.$$iframes.forEach(($iframe) => {
            if (!$iframe.hasAttribute('srcdoc')) {
                return;
            }

            // src first: removing srcdoc then navigates straight to it (the other way round loads about:blank)
            $iframe.consentPlaceholder = $iframe.getAttribute('srcdoc');
            $iframe.src = $iframe.dataset.consentSrc;
            $iframe.removeAttribute('srcdoc');
        });

        const $api = document.getElementById('GRAHOU_tracking_youtube_api');
        if ($api && !this.apiLoaded && document.querySelector('.youtube-container')) {
            this.apiLoaded = true;
            document.body.append(document.createRange().createContextualFragment($api.innerHTML));
        }
    }

    #disable() {
        this.$$blocks.forEach(($item) => {
            $item.player?.destroy();
            $item.player = null;
            $item.querySelector('iframe')?.removeAttribute('src');
            $item.classList.add('no_consent');
        });

        this.$$iframes.forEach(($iframe) => {
            if ($iframe.consentPlaceholder) {
                $iframe.setAttribute('srcdoc', $iframe.consentPlaceholder);
                $iframe.removeAttribute('src');
            }
        });
    }
}
